import { combineURLs } from '@dvb/common';
import { externalAxios } from '@school-manage/api/client';

export const getMinimumVersionRequest = async () => {
  const { data } = await externalAxios.get<string>(
    combineURLs(
      import.meta.env.VITE_APP_APP_SERVICE_BASE_URL,
      '/minimum-version'
    )
  );
  return data;
};
